import { HIPAA, PRIVACY, TERMS_AND_CONDITIONS } from "@/core/constants";
import { createAcknowledgement, createAcknowledgementV2 } from "./acknowledgementUtils";
import { getCurrentPolicyVersion } from "@/lib/helpers/getCurrentPolicyVersion";

/**
 * @deprecated This function is only asynchronous due to fetching of client IP, which we no longer
 * do, see https://aptihealth.atlassian.net/issues/AT1-6695. Use createImplicitConsentV2 instead
 */
export const createImplicitConsent = async (policyMetadata) => {
  const acknowledgement = await createAcknowledgement({ consentResponse: true });

  return {
    eula: [
      {
        ...acknowledgement,
        version: getCurrentPolicyVersion({ policyMetadata, policy: "TERMS_AND_CONDITIONS" }),
      },
    ],
    privacy: [
      {
        ...acknowledgement,
        version: getCurrentPolicyVersion({ policyMetadata, policy: "PRIVACY" }),
      },
    ],
    hipaa: [
      { ...acknowledgement, version: getCurrentPolicyVersion({ policyMetadata, policy: "HIPAA" }) },
    ],
  };
};

export const createImplicitConsentV2 = (policyMetadata, isGivenOnBehalf = false) => {
  const policyMapping = {
    eula: TERMS_AND_CONDITIONS,
    privacy: PRIVACY,
    hipaa: HIPAA,
  };

  return Object.fromEntries(
    Object.entries(policyMapping).map(([key, value]) => [
      key,
      [
        createAcknowledgementV2({
          isGivenOnBehalf,
          policyVersion: policyMetadata[value]?.current_version,
        }),
      ],
    ]),
  );
};

export function createPolicyConsentEntry(
  targetPatientId,
  consent,
  consentType,
  impliedConcentPolicyVersion,
) {
  return {
    consent,
    consent_type: consentType,
    implied_consent_policy_versions: impliedConcentPolicyVersion,
    target_patient_id: targetPatientId,
  };
}
